import {useContext, useEffect} from 'react';
import {get, isNil} from 'lodash';

import {RecordsFilterContext} from '/context/RecordsFilter';

export function useRecordsFiltering({recordsName}: any) {
  // @ts-expect-error TS(2339): Property 'filterParam' does not exist on type 'unk... Remove this comment to see the full error message
  const {filterParams, setInitialFilterParams} =
    useContext(RecordsFilterContext);
  const filterParam = get(filterParams, recordsName);
  useEffect(() => {
    if (isNil(filterParam)) {
      setInitialFilterParams({recordsName});
    }
  }, [filterParam]);

  return {isReadyToLoad: !isNil(filterParam), filterParam: filterParam || {}};
}
